module.exports = __webpack_public_path__ + "static/img/bot-step-1.b9468b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bot-step-1.png
// module id = Vfzh
// module chunks = 11